import "./car-service-about.css";
import { Helmet } from "react-helmet";

const About = () => {
  return (
    <>
      <Helmet>
        <script type="application/ld+json">
{`
{
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "name": "About AutoCare Car Repair",
  "description": "AutoCare Car Repair is a trusted car service provider offering professional car repair and maintenance services in Palwal.",
  "about": {
    "@type": "LocalBusiness",
    "name": "AutoCare Car Repair",
    "areaServed": {
      "@type": "Place",
      "name": "Palwal"
    }
  }
}
`}
</script>
        <title>About AutoCare | Trusted Luxury Car Servicing in Palwal</title>

        <meta
          name="description"
          content="Learn about AutoCare, a trusted luxury car service provider in Palwal offering OEM parts, skilled technicians, transparent pricing, and doorstep pick-up & drop services."
        />

        <link
          rel="canonical"
          href="https://car-repair-mechanic-palwal.netlify.app/about"
        />

        {/* Open Graph */}
        <meta property="og:title" content="About AutoCare" />
        <meta
          property="og:description"
          content="Premium luxury car servicing in Palwal with genuine OEM parts and expert technicians."
        />
        <meta
          property="og:image"
          content="https://yourdomain.com/carServiceImages/aboutimg.webp"
        />
        <meta
          property="og:url"
          content="https://yourdomain.com/about"
        />
        <link
          rel="canonical"
          href="https://car-repair-mechanic-palwal.netlify.app/about"
        />
      </Helmet>

      <section className="aboutSection">
        <div className="aboutContent">
          <div className="aboutText">
            <h1>About AutoCare</h1>

            <p>
              AutoCare’s mission is to deliver premium-quality care for your luxury
              car at affordable pricing. We ensure real-time updates for all your
              car care needs with a fair and transparent pricing mechanism.
            </p>

            <p>
              Customer satisfaction lies at the heart of everything we do at
              AutoCare. With online appointment scheduling and doorstep same-day
              pick-up and drop services across Palwal, we maximize convenience.
            </p>

            <p className="aboutNote">
              This website is owned and operated by{" ABHI"}
              <strong>KINGS CAR CARE LLP</strong>. AutoCare is the brand name.
            </p>
          </div>

          <div className="aboutImage">
            <img
              src="/carServiceImages/aboutimg.webp"
              alt="AutoCare luxury car service workshop in Palwal"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
